export default "__VITE_ASSET__0pzRZVal__"